<template>
  <Page>
    <div class="topimg"></div>
    <div class="con">
      
      <List :list='newslist' type="media"></List>

    </div>
  </Page>
</template>

<script>
import Page  from '@/components/page.vue'
import List  from '@/components/List/news-list.vue'

import {getMediaList} from '@/api/dynamic.js'


export default {
  name: '',
  components:{Page,List},
  data(){
    return {
      tabCheIndex:0,
      newslist:[]
    }
  },
  created(){
    getMediaList().then(res=>{
      this.newslist = res;
    })
  },
  methods:{
    changeTab(idx){
      this.tabCheIndex=idx;
    }
  }
}
</script>

<style scoped>
.topimg{width:100%; height:9.42vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:100% 100%;}

.con{padding:4.47vw 5.26vw;}


@media (max-width:991px){
.fs16{font-size:2.8vw; line-height:2.8vw;}
.topimg{width:100%; height:20vw; background:url(../../assets/breadcrumb/001.jpg) no-repeat center; background-size:cover;}
.con{padding:6vw 1.5vw;}


}
</style>


